if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      this.startDate = this.dataset.startDate ? new Date(this.dataset.startDate).getTime() : null;
      this.loopTime = this.dataset.loopTime ? this.parseLoopTime(this.dataset.loopTime) : null;
      
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    // Parse loop time format, e.g., "48:00" to milliseconds
    parseLoopTime(loopTimeStr) {
      const [hours, minutes] = loopTimeStr.split(':').map(Number);
      const hourMs = 60 * 60 * 1000; // Milliseconds in 1 hour
      const minuteMs = 60 * 1000; // Milliseconds in 1 minute
      return (hours * hourMs) + (minutes * minuteMs);
    }
    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const now = new Date().getTime();
      
      // Check if end date has been reached
      if (now >= this.endDate) {
        clearInterval(this.interval);
        return;
      }
      
      // Check if before start date
      if (this.startDate && now < this.startDate) {
        // Before start date, do not display countdown
        this.daysEl.textContent = '00';
        this.hoursEl.textContent = '00';
        this.minsEl.textContent = '00';
        this.secsEl.textContent = '00';
        return;
      }
      
      let timeDiff;
      
      // Calculate loop countdown
      if (this.loopTime) {
        // Calculate total milliseconds from start date to now
        const totalElapsed = now - (this.startDate || 0);
        // Calculate remaining time in current loop cycle
        timeDiff = this.loopTime - (totalElapsed % this.loopTime);
      } else {
        // Non-loop mode, directly calculate remaining time to end date
        timeDiff = this.endDate - now;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.daysEl.textContent = days.toString().padStart(2, '0');
      this.hoursEl.textContent = (hours - days * 24).toString().padStart(2, '0');
      this.minsEl.textContent = (mins - hours * 60).toString().padStart(2, '0');
      this.secsEl.textContent = (secs - mins * 60).toString().padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
